import React from 'react';
import PropTypes from 'prop-types';
import {
  Button, Card, CardBody, CardHeader, Col, Row,
} from 'reactstrap';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { fetchCities } from '../../actions/cities';
import DataTable from '../../components/data-table';

const COLUMNS = [
  { id: 'id', label: 'ID', link: true },
  { id: 'name', label: 'Name', link: true },
  { id: 'name_arabic', label: 'Name Arabic' },
  { id: 'country.name', label: 'Country' },
  { id: 'code', label: 'Code' },
  { id: 'state', label: 'State' },
  { id: 'calculationMethod.name', label: 'Calculation Method' },
  { id: 'version', label: 'Version' },
];

const Cities = (props) => {
  const { getCities } = props;
  return (
    <div className="animated fadeIn">
      <Row>
        <Col xl={12}>
          <Card>
            <CardHeader>
              <Row>
                <Col lg={4}>Cities</Col>
                <Col lg={8} style={{ textAlign: 'right' }}>
                  <Button href="/#/cities/new" color="success" size="sm">
                    New
                  </Button>
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              <DataTable resource="cities" dataSource={getCities} columns={COLUMNS} {...props} />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

Cities.propTypes = {
  getCities: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  cities: PropTypes.arrayOf(PropTypes.object),
};

Cities.defaultProps = {
  cities: [],
};

const mapStateToProps = ({ cities }) => ({
  loading: cities.loading,
  cities: cities.items,
});

const mapDispatchToProps = dispatch => bindActionCreators(
  {
    getCities: sort => fetchCities(sort),
  },
  dispatch,
);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Cities);
